import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    overflow: ${({ shouldScroll }) => (shouldScroll ? 'auto' : 'hidden')};
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  button,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    border: 0;
    padding: 0;
    font: inherit;
    font-size: 100%;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  section {
    display: block;
  }

  body {
    overflow: hidden;
    max-width: min(1920px, 100vw);
    min-height: 100vh;
    margin: auto;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
    color: ${({ theme }) => theme.getColor('main')};
    font-family: ${({ theme }) => theme.getFont()};
    line-height: 1.2;
  }

  ol[class],
  ul[class] {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;

    &::before,
    &::after {
      content: '';
      content: none;
    }
  }

  table {
    border-spacing: 0;
    border-collapse: collapse;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  img,
  picture {
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  sup {
    font-size: 50%;
    vertical-align: super;
  }

  sub {
    font-size: 50%;
    vertical-align: sub;
  }

  @keyframes slideFade {
    to {
      opacity: 0;
      transform: translate(-50%, 100%);
    }
  }

  @keyframes fade {
    to {
      opacity: 0;
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(359deg);
    }
  }

  @keyframes glow {
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      transition-duration: 0.01ms !important;
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      scroll-behavior: auto !important;
    }
  }

  #onetrust-consent-sdk {
    display: ${process.env.NODE_ENV === 'development' && 'none'};
  }

  .copy {
    color: ${({ theme }) => theme.colors.copy}
  }

  .alt {
    color: ${({ theme }) => theme.colors.alt};
  }

  .accent {
    color: ${({ theme }) => theme.colors.accent};
  }

  .dim {
    color: ${({ theme }) => theme.colors.dim};
  }

  .highlight {
    color: ${({ theme }) => theme.colors.highlight};
  }

  .light {
    color: ${({ theme }) => theme.colors.link};
  }

  .main {
    color: ${({ theme }) => theme.colors.main};
  }

  .player {
    color: ${({ theme }) => theme.colors.player};
  }

  .header {
    color: ${({ theme }) => theme.colors.products.header};
  }

  .baby {
    color: ${({ theme }) => theme.colors.products.baby};
  }

  .forte {
    color: ${({ theme }) => theme.colors.products.forte};
  }

  .junior {
    color: ${({ theme }) => theme.colors.products.junior};
  }

  .kids {
    color: ${({ theme }) => theme.colors.products.kids};
  }

  .mini {
    color: ${({ theme }) => theme.colors.products.mini};
  }

  .night {
    color: ${({ theme }) => theme.colors.products.night};
  }

  .spray {
    color: ${({ theme }) => theme.colors.products.spray};
  }
`;
